import { useEffect } from 'react'
import { useGameStore } from '../store/useGameStore'

export function useGameTick(enabled: boolean, intervalMs: number = 1000) {
  const tick = useGameStore((s) => s.tick)
  useEffect(() => {
    if (!enabled) return
    tick(Date.now())
    const id = window.setInterval(() => tick(Date.now()), intervalMs)
    return () => window.clearInterval(id)
  }, [enabled, tick, intervalMs])
}
